<ul class="d-flex flex-wrap list-unstyled">
  <ng-container [ngSwitch]="type" *ngFor="let item of items; let i = index">
    <li *ngSwitchCase="showcasesTypes.CONTRIBUTORS"
        class="item col-sm-6 col-md-4 mb-8">
      <app-contributor
        [contributor]="item"
        [focusedId]="focusedId"
        [isMouseEvent]="isMouseEvent"
        [identifier]="identifier"
        [index]="i">
      </app-contributor>
    </li>
    <li *ngSwitchCase="(type === showcasesTypes.TOPICS
          || (type === showcasesTypes.CUSTOM && isMultipleView))
          ? type : '' "
        class="col-md-6 d-flex flex-column justify-content-between multiple-showcase px-0 px-md-4 mb-6 mb-sm-9 mb-md-15">
      <app-multiple-showcase
        [attr.data-automation-id]="type === showcasesTypes.TOPICS ? 'topic' : type"
        [showcase]="item"
        [index]="i"
        [showcaseType]="type"
        [entity]="entity">
      </app-multiple-showcase>
    </li>
    <li class="item mb-8 mb-sm-13 mr-sm-4" *ngSwitchDefault>
      <app-single-showcase-resource
        [resource]="item"
        [index]="i"
        [entityId]="entity.id"
        [showcaseType]="type">
      </app-single-showcase-resource>
    </li>
  </ng-container>
</ul>
